import Dropdown, { DropdownModel } from '@components/dropdown';
import SvgIcon, { Icon } from '@components/svg-icon';
import { useLanguage } from '@shared/contexts/languageContext';
import { useComponentVisibility } from '@shared/hooks';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';

const LanguagePicker = () => {
    const { language, toggleLanguage } = useLanguage();
    const [isVisible, setIsVisible, elementRef] = useComponentVisibility<HTMLDivElement>(false);

    const languageDropdownModel: DropdownModel = {
        defaultValue: language,
        items: [
            { label: 'English', value: 'en', icon: <SvgIcon type={Icon.UsaLanguage} className='icon-small' /> },
            { label: 'Español', value: 'es', icon: <SvgIcon type={Icon.SpanishLanguage} className='icon-small' /> }
        ],
        onClick: (id, item) => {
            if (!!item?.value) {
                changeLanguage(item.value);
            }
        }
    }
    const changeLanguage = (lng: string) => {
        toggleLanguage(lng);
    };
    const openLanguagePicker = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        setIsVisible(!isVisible);
    }
    const [popper, setPopper] = useState<HTMLDivElement | null>(null);
    const { styles, attributes, update } = usePopper(elementRef.current, popper, {
        placement: 'bottom',
        strategy: 'fixed',
        modifiers: [{
            name: 'offset',
            options: {
                offset: [0, 8],
            },
        }]
    });
    useEffect(() => {
        if (isVisible && update) {
            update().then();
        }
    }, [update, isVisible]);

    const displayCurrentLanguage = () => {
        const languageIcon = language === 'en' ? Icon.UsaLanguage : Icon.SpanishLanguage;
        const languageLabel = language === 'en' ? 'English' : 'Español';
        return <div className='flex subtitle2-white'>
            <span className='pr-2'>{languageLabel}</span>
            <SvgIcon type={languageIcon} className='icon-medium' />
        </div>;
    }

    return (
        <>
            <div ref={elementRef} className='flex flex-row items-center cursor-pointer' onClick={openLanguagePicker}>
                <div className='pl-3'>
                    {
                        displayCurrentLanguage()
                    }
                </div>

                <SvgIcon type={!isVisible ? Icon.ArrowDown : Icon.ArrowUp}
                    fillClass='active-item-icon' />
            </div>
            <div
                className={classnames('z-10', { 'hidden': !isVisible })}
                style={styles.popper}
                ref={setPopper}
                {...attributes.popper}
            >
                <Dropdown model={languageDropdownModel} />
            </div>
        </>
    )
}

export default LanguagePicker;